import React from 'react';
import Select from '@amzn/awsui-components-console/select';
import SpaceBetween from '@amzn/awsui-components-console/space-between';
import SIMTrackerContainer from './SIMTrackerContainer';

interface SelectOption {
    label?: string;
    value?: string;
}

interface SIMTask {
    taskExecutionId: string;
    taskId: string;
    status: string;
    taskName: string;
    taskType: string;
    [key: string]: unknown;
}

interface SIMComponentProps {
    simTasks: SIMTask[];
    workflowName: string;
}

interface SIMComponentState {
    selectedOption: SelectOption;
    options: SelectOption[];
    simTasks: SIMTask[];
    filteredTasks: SIMTask[];
}

export default class SIMComponent extends React.Component<SIMComponentProps, SIMComponentState> {
	constructor(props: SIMComponentProps) {
		super(props);
		const options: SelectOption[] = [
			{
				label: 'All SIM / TTs',
				value: 'ALL',
			},
			{
				label: 'Open SIM / TTs',
				value: 'OPEN',
			},
		];

		this.state = {
			selectedOption: options[1],
			options,
			simTasks: this.props.simTasks,
			filteredTasks: this.props.simTasks.filter((item) =>
				this.isTaskOpen(item)
			),
		};
		this.onFilterChange = this.onFilterChange.bind(this);
		this.filterSIMTasks = this.filterSIMTasks.bind(this);
		this.isTaskOpen = this.isTaskOpen.bind(this);
	}

	render(): JSX.Element {
		return (
			<SpaceBetween size="l">
				<Select
					options={this.state.options}
					selectedOption={this.state.selectedOption}
					onChange={this.onFilterChange}
				/>

				{this.state.filteredTasks.length > 0 ? (
					<SpaceBetween size="m">
						{this.state.filteredTasks.map((value) => {
							return this.getExpandableContainer(value);
						})}
					</SpaceBetween>
				) : (
					<div className="awsui-util-t-c">
						<div className="awsui-util-pt-s awsui-util-mb-xs">
							<b>No Tasks</b>
						</div>
						<div className="awsui-util-mb-s">No Tasks to display.</div>
					</div>
				)}
			</SpaceBetween>
		);
	}

	isTaskOpen(task: SIMTask): boolean {
		return (
			task.status !== 'COMPLETED' &&
            task.status !== 'OVERRIDEN' &&
            task.status !== 'CANCELLED' &&
            task.status !== 'SKIPPED' &&
            task.status !== 'WAITING'
		);
	}

	onFilterChange(event: { detail: { selectedOption: SelectOption } }): void {
		this.setState({
			selectedOption: event.detail.selectedOption,
			filteredTasks: this.filterSIMTasks(
				this.state.simTasks,
				event.detail.selectedOption.value || ''
			),
		});
	}

	filterSIMTasks(Items: SIMTask[], filter: string): SIMTask[] {
		if (filter === 'OPEN') {
			return Items.filter((item) => this.isTaskOpen(item));
		} else {
			return Items;
		}
	}

	getExpandableContainer(task: SIMTask): JSX.Element {
		return (
			<SIMTrackerContainer
				key={task.taskExecutionId || task.taskId}
				task={task}
				workflowName={this.props.workflowName}
				status={task.status}
			/>
		);
	}
}
